export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
